import React from 'react'
import {Input} from 'semantic-ui-react'

export const PositiveNumInput =(props)=>{
    const onChange=(e, {value, name})=>{
        const num=Number(value)
        if(Number.isNaN(num)){
            return null
        }
        if(num < 0){
            return null
        }
        props.onChange(e, {value:num, name})
    }
    return (
        <div className='inputInt'>
            <Input  
                 value={props.value}
                 onChange={onChange}
                 name={props.name}
                 className={props.className}
                 placeholder={props.placeholder}
                 iconPosition={props.iconPosition}
                 label={props.label}
                 type='number'
                 disabled={props.disabled}
                 required={props.required}
             /> 
        </div>
    )
}
export default PositiveNumInput